import { render, staticRenderFns } from "./RedEnvelopes.vue?vue&type=template&id=88924a32&scoped=true"
import script from "./RedEnvelopes.vue?vue&type=script&lang=js"
export * from "./RedEnvelopes.vue?vue&type=script&lang=js"
import style0 from "./RedEnvelopes.vue?vue&type=style&index=0&id=88924a32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88924a32",
  null
  
)

export default component.exports